import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "me-1 pi pi-fw pi-file" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Info", -1)
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = { class: "col-md-12 p-4" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Name:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Email Address:")
], -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-3 d-flex align-items-center"
}
const _hoisted_18 = { class: "pi pi-lock text-danger" }
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Phone Number:")
], -1)
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "row mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Role:")
], -1)
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Status:")
], -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "row mb-3" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Accessible Company:", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "col-md-9" }
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = { class: "row mb-3" }
const _hoisted_38 = {
  key: 0,
  class: "error-no-record mt-3"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_40 = { class: "row mb-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_42 = { class: "d-flex col-md-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "me-1 pi pi-fw pi-lock" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "Password", -1)
const _hoisted_46 = {
  key: 1,
  class: "row"
}
const _hoisted_47 = { class: "col-md-12 p-4 d-flex" }
const _hoisted_48 = { class: "col-md-8 pe-2" }
const _hoisted_49 = { class: "row mb-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "New Password:")
], -1)
const _hoisted_51 = { class: "col-md-7" }
const _hoisted_52 = { class: "row mb-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Confirm Password:")
], -1)
const _hoisted_54 = { class: "col-md-7" }
const _hoisted_55 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_56 = {
  key: 1,
  class: "col-md-7 p-error"
}
const _hoisted_57 = { class: "col-md-4 ps-2" }
const _hoisted_58 = { class: "col-md-12" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-password-policy-title" }, "Password Policy:", -1)
const _hoisted_62 = { class: "pl-2 ml-2 mt-0 col-form-password-policy" }
const _hoisted_63 = { class: "row mb-3" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_65 = { class: "d-flex col-md-6" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_67 = {
  key: 1,
  class: "p-1"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "me-1 pi pi-fw pi-shield" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", null, "2FA", -1)
const _hoisted_70 = {
  key: 1,
  class: "row"
}
const _hoisted_71 = { class: "col-md-12 p-4" }
const _hoisted_72 = { class: "row mb-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Last Login:")
], -1)
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "col-form-label-text" }
const _hoisted_76 = { class: "row mb-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Device Model:")
], -1)
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = { class: "col-form-label-text" }
const _hoisted_80 = { class: "row mb-3" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Device Platform:")
], -1)
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "col-form-label-text" }
const _hoisted_84 = { class: "row mb-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_86 = { class: "d-flex col-md-6" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "me-1 pi pi-envelope" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", null, "Email Controller", -1)
const _hoisted_89 = {
  key: 1,
  class: "row"
}
const _hoisted_90 = { class: "col-md-12 p-4" }
const _hoisted_91 = { class: "row mb-3" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Company:")
], -1)
const _hoisted_93 = { class: "col-md-6" }
const _hoisted_94 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_95 = { class: "col-md-3" }
const _hoisted_96 = { class: "col-md-9" }
const _hoisted_97 = { class: "col-md-2" }
const _hoisted_98 = { class: "row mb-3" }
const _hoisted_99 = {
  key: 0,
  class: "error-no-record mt-3"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_101 = { class: "row mb-3" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_103 = { class: "d-flex col-md-6" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Password = _resolveComponent("Password")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader, {
                onDeleteEvent: _ctx.deleteUser,
                renderDelete: (_ctx.identifier != null ? true : false),
                isDeleting: _ctx.isDeleting
              }, null, 8, ["onDeleteEvent", "renderDelete", "isDeleting"]),
              (_ctx.pageError == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_TabView, { class: "p-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TabPanel, null, {
                          header: _withCtx(() => [
                            _hoisted_7,
                            _hoisted_8
                          ]),
                          default: _withCtx(() => [
                            (_ctx.isPageLoading)
                              ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                              : _createCommentVNode("", true),
                            (!_ctx.isPageLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _hoisted_12,
                                      _createElementVNode("div", _hoisted_13, [
                                        _createVNode(_component_InputText, {
                                          class: "p-inputtext",
                                          type: "text",
                                          maxlength: "50",
                                          placeholder: "Name",
                                          modelValue: _ctx.user.employee.name,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.employee.name) = $event)),
                                          disabled: !_ctx.isAdmin && _ctx.userRole == 'Admin'
                                        }, null, 8, ["modelValue", "disabled"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                      _hoisted_15,
                                      _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_InputText, {
                                          class: "p-inputtext",
                                          type: "text",
                                          maxlength: "50",
                                          placeholder: "Email Address",
                                          modelValue: _ctx.user.employee.emailAddress,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.employee.emailAddress) = $event)),
                                          disabled: _ctx.identifier != null
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      (_ctx.user.failedLoginCount >= 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _withDirectives(_createElementVNode("i", _hoisted_18, null, 512), [
                                              [
                                                _directive_tooltip,
                                                {value: 'Account Locked'},
                                                void 0,
                                                { right: true }
                                              ]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                      _hoisted_20,
                                      _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_InputText, {
                                          class: "p-inputtext",
                                          type: "text",
                                          maxlength: "15",
                                          placeholder: "Phone Number",
                                          modelValue: _ctx.user.employee.mobilePhone,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.employee.mobilePhone) = $event)),
                                          onKeypress: _ctx.filterNonNumeric,
                                          disabled: !_ctx.isAdmin && _ctx.userRole == 'Admin'
                                        }, null, 8, ["modelValue", "onKeypress", "disabled"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                      _hoisted_23,
                                      _createElementVNode("div", _hoisted_24, [
                                        _createVNode(_component_Dropdown, {
                                          options: _ctx.filterUserRoles,
                                          optionLabel: "name",
                                          optionValue: "value",
                                          placeholder: "-- Please Select --",
                                          modelValue: _ctx.userRole,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userRole) = $event)),
                                          display: "chip",
                                          onChange: _ctx.resetCompanies,
                                          disabled: !_ctx.isAdmin && _ctx.userRole == 'Admin'
                                        }, null, 8, ["options", "modelValue", "onChange", "disabled"])
                                      ])
                                    ]),
                                    (_ctx.identifier != null)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          _hoisted_26,
                                          _createElementVNode("div", _hoisted_27, [
                                            _createVNode(_component_Dropdown, {
                                              options: _ctx.getActiveStatuses(_ctx.statuses),
                                              optionLabel: "name",
                                              optionValue: "value",
                                              placeholder: "-- Please Select --",
                                              modelValue: _ctx.user.isClosed,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.isClosed) = $event)),
                                              disabled: !_ctx.isAdmin && _ctx.userRole == 'Admin'
                                            }, null, 8, ["options", "modelValue", "disabled"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createVNode(_component_Divider)
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["col-md-3", _ctx.userRole == 'RPK User' ? 'required' : '' ])
                                      }, _hoisted_31, 2),
                                      _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_component_MultiSelect, {
                                          virtualScrollerOptions: { itemSize: 44 },
                                          options: _ctx.companies,
                                          optionLabel: "code",
                                          display: "chip",
                                          filter: "",
                                          filterFields: ['code', 'name'],
                                          showClear: "",
                                          placeholder: _ctx.isCompanyLoading ? ('Loading...') : '-- Please Select --',
                                          loading: _ctx.isCompanyLoading,
                                          modelValue: _ctx.selectedCompanies,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                                          disabled: !(_ctx.userRole == 'RPK User')
                                        }, {
                                          option: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_33, [
                                              _createElementVNode("span", _hoisted_34, _toDisplayString(slotProps.option.code), 1),
                                              _createElementVNode("span", _hoisted_35, _toDisplayString(slotProps.option.name), 1)
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["options", "placeholder", "loading", "modelValue", "disabled"])
                                      ]),
                                      _createElementVNode("div", _hoisted_36, [
                                        _createVNode(_component_Button, {
                                          icon: "pi pi-plus",
                                          onClick: _ctx.addCompanies,
                                          disabled: _ctx.selectedCompanies.length == 0 || _ctx.userRole != 'RPK User'
                                        }, null, 8, ["onClick", "disabled"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createVNode(_component_DataTable, {
                                        value: _ctx.user.employee.employeeCompanies,
                                        responsiveLayout: "scroll",
                                        selectionMode: "single"
                                      }, {
                                        empty: _withCtx(() => [
                                          (_ctx.user.employee.employeeCompanies.length <= 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                _createVNode(_component_FontAwesomeIcon, {
                                                  icon: ['fas', 'image'],
                                                  size: "2x"
                                                }),
                                                _hoisted_39
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            style: {"width":"90%"},
                                            field: "company.name",
                                            header: "Accessible Company"
                                          }),
                                          _createVNode(_component_Column, {
                                            style: {"width":"10%"},
                                            header: ""
                                          }, {
                                            body: _withCtx((slotProps) => [
                                              _createVNode(_component_Button, {
                                                icon: "pi pi-trash",
                                                severity: "danger",
                                                text: "",
                                                rounded: "",
                                                onClick: ($event: any) => (_ctx.removeCompany(slotProps.index)),
                                                title: "Remove"
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                      _hoisted_41,
                                      _createElementVNode("div", _hoisted_42, [
                                        _createVNode(_component_Button, {
                                          class: "p-button-sm",
                                          disabled: _ctx.v$.user.$invalid || _ctx.v$.userRole.$invalid || _ctx.isLoading || (!_ctx.isAdmin && _ctx.userRole == 'Admin'),
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.identifier == null ? _ctx.save() : _ctx.update())),
                                          label: "Save"
                                        }, null, 8, ["disabled"]),
                                        _hoisted_43,
                                        _createVNode(_component_Button, {
                                          class: "p-button-sm p-button-secondary",
                                          onClick: _ctx.cancel,
                                          label: "Cancel"
                                        }, null, 8, ["onClick"]),
                                        (_ctx.isLoading)
                                          ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_ctx.identifier != null && _ctx.isAdmin)
                          ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                              header: _withCtx(() => [
                                _hoisted_44,
                                _hoisted_45
                              ]),
                              default: _withCtx(() => [
                                (_ctx.isPageLoading)
                                  ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                                  : _createCommentVNode("", true),
                                (!_ctx.isPageLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("div", _hoisted_48, [
                                          _createElementVNode("div", _hoisted_49, [
                                            _hoisted_50,
                                            _createElementVNode("div", _hoisted_51, [
                                              _createVNode(_component_Password, {
                                                strongRegex: _ctx.strongRegex,
                                                class: _normalizeClass({'p-invalid': (_ctx.passwordNotMatch || _ctx.v$.password.newPassword.strongRegexValidator.$invalid) && _ctx.password.newPassword != ''}),
                                                maxlength: "50",
                                                placeholder: "New Password",
                                                toggleMask: "",
                                                modelValue: _ctx.password.newPassword,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.password.newPassword) = $event))
                                              }, null, 8, ["strongRegex", "class", "modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_52, [
                                            _hoisted_53,
                                            _createElementVNode("div", _hoisted_54, [
                                              _createVNode(_component_Password, {
                                                strongRegex: _ctx.strongRegex,
                                                class: _normalizeClass({'p-invalid': (_ctx.passwordNotMatch || _ctx.v$.password.confirmPassword.strongRegexValidator.$invalid) && _ctx.password.confirmPassword != ''}),
                                                maxlength: "50",
                                                placeholder: "Confirm Password",
                                                toggleMask: "",
                                                modelValue: _ctx.password.confirmPassword,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.password.confirmPassword) = $event))
                                              }, null, 8, ["strongRegex", "class", "modelValue"])
                                            ]),
                                            (_ctx.passwordNotMatch)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_55))
                                              : _createCommentVNode("", true),
                                            (_ctx.passwordNotMatch)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_56, "Passwords do not matched."))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_57, [
                                          _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                              _createElementVNode("div", _hoisted_60, [
                                                _hoisted_61,
                                                _createElementVNode("ul", _hoisted_62, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordPolicy, (policies) => {
                                                    return (_openBlock(), _createElementBlock("li", { key: policies }, _toDisplayString(policies), 1))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_63, [
                                        _hoisted_64,
                                        _createElementVNode("div", _hoisted_65, [
                                          _createVNode(_component_Button, {
                                            class: "p-button-sm",
                                            disabled: _ctx.v$.password.$invalid || _ctx.isLoading,
                                            onClick: _ctx.updatePassword,
                                            label: "Save"
                                          }, null, 8, ["disabled", "onClick"]),
                                          _hoisted_66,
                                          (_ctx.identifier != null)
                                            ? (_openBlock(), _createBlock(_component_Button, {
                                                key: 0,
                                                class: "p-button-sm p-button-warning",
                                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetPassword())),
                                                label: "Reset Password",
                                                disabled: _ctx.user.isClosed
                                              }, null, 8, ["disabled"]))
                                            : _createCommentVNode("", true),
                                          (_ctx.identifier != null)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_67))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_Button, {
                                            class: "p-button-sm p-button-secondary",
                                            onClick: _ctx.cancel,
                                            label: "Cancel"
                                          }, null, 8, ["onClick"]),
                                          (_ctx.isLoading)
                                            ? (_openBlock(), _createBlock(_component_TheLoading, { key: 2 }))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isRoot)
                          ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                              header: _withCtx(() => [
                                _hoisted_68,
                                _hoisted_69
                              ]),
                              default: _withCtx(() => [
                                (_ctx.isPageLoading)
                                  ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                                  : _createCommentVNode("", true),
                                (!_ctx.isPageLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                      _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("div", _hoisted_72, [
                                          _hoisted_73,
                                          _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("label", _hoisted_75, _toDisplayString((_ctx.ciscoDuo2FA.lastLogin == null ? "-" : _ctx.ciscoDuo2FA.lastLogin)), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_76, [
                                          _hoisted_77,
                                          _createElementVNode("div", _hoisted_78, [
                                            _createElementVNode("label", _hoisted_79, _toDisplayString((_ctx.ciscoDuo2FA.deviceModel == null ? "-" : _ctx.ciscoDuo2FA.deviceModel)), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_80, [
                                          _hoisted_81,
                                          _createElementVNode("div", _hoisted_82, [
                                            _createElementVNode("label", _hoisted_83, _toDisplayString((_ctx.ciscoDuo2FA.devicePlatform == null ? "-" : _ctx.ciscoDuo2FA.devicePlatform)), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_84, [
                                          _hoisted_85,
                                          _createElementVNode("div", _hoisted_86, [
                                            _createVNode(_component_Button, {
                                              class: "p-button-sm p-button-warning",
                                              disabled: _ctx.isLoading || (_ctx.ciscoDuo2FA.deviceModel == null && _ctx.ciscoDuo2FA.devicePlatform == null),
                                              onClick: _ctx.reset2FA,
                                              label: "Reset"
                                            }, null, 8, ["disabled", "onClick"]),
                                            (_ctx.isLoading)
                                              ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_TabPanel, {
                          disabled: _ctx.userRole == 'RPK User'
                        }, {
                          header: _withCtx(() => [
                            _hoisted_87,
                            _hoisted_88
                          ]),
                          default: _withCtx(() => [
                            (_ctx.isPageLoading)
                              ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                              : _createCommentVNode("", true),
                            (!_ctx.isPageLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("div", _hoisted_91, [
                                      _hoisted_92,
                                      _createElementVNode("div", _hoisted_93, [
                                        _createVNode(_component_MultiSelect, {
                                          virtualScrollerOptions: { itemSize : 44 },
                                          options: _ctx.companies,
                                          optionLabel: "code",
                                          display: "chip",
                                          filter: "",
                                          filterFields: ['code', 'name'],
                                          showClear: "",
                                          placeholder: _ctx.isEmailCompanyLoading ? ('Loading...') : '-- Please Select --',
                                          loading: _ctx.isEmailCompanyLoading,
                                          modelValue: _ctx.selectedEmailCompanies,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedEmailCompanies) = $event)),
                                          disabled: !_ctx.isAdmin && _ctx.userRole == 'Admin'
                                        }, {
                                          option: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_94, [
                                              _createElementVNode("span", _hoisted_95, _toDisplayString(slotProps.option.code), 1),
                                              _createElementVNode("span", _hoisted_96, _toDisplayString(slotProps.option.name), 1)
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["options", "placeholder", "loading", "modelValue", "disabled"])
                                      ]),
                                      _createElementVNode("div", _hoisted_97, [
                                        _createVNode(_component_Button, {
                                          icon: "pi pi-plus",
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addEmailCompanies())),
                                          disabled: _ctx.selectedEmailCompanies.length == 0 || (!_ctx.isAdmin && _ctx.userRole == 'Admin')
                                        }, null, 8, ["disabled"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_98, [
                                      _createVNode(_component_DataTable, {
                                        value: _ctx.user.employee.employeeEmailCompanies,
                                        responsiveLayout: "scroll",
                                        selectionMode: "single"
                                      }, {
                                        empty: _withCtx(() => [
                                          (_ctx.user.employee.employeeEmailCompanies.length <= 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                                _createVNode(_component_FontAwesomeIcon, {
                                                  icon: ['fas', 'image'],
                                                  size: "2x"
                                                }),
                                                _hoisted_100
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            style: {"width":"90%"},
                                            field: "emailCompany.name",
                                            header: "Company:"
                                          }),
                                          (_ctx.isAdmin || _ctx.userRole != 'Admin')
                                            ? (_openBlock(), _createBlock(_component_Column, {
                                                key: 0,
                                                style: {"width":"10%"},
                                                header: ""
                                              }, {
                                                body: _withCtx((slotProps) => [
                                                  _createVNode(_component_Button, {
                                                    icon: "pi pi-trash",
                                                    severity: "danger",
                                                    text: "",
                                                    rounded: "",
                                                    onClick: ($event: any) => (_ctx.removeEmailCompany(slotProps.index)),
                                                    title: "Remove"
                                                  }, null, 8, ["onClick"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_101, [
                                      _hoisted_102,
                                      _createElementVNode("div", _hoisted_103, [
                                        _createVNode(_component_Button, {
                                          class: "p-button-sm",
                                          disabled: _ctx.v$.user.$invalid || _ctx.v$.userRole.$invalid || _ctx.isLoading || (!_ctx.isAdmin && _ctx.userRole == 'Admin'),
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.identifier == null ? _ctx.save() : _ctx.update())),
                                          label: "Save"
                                        }, null, 8, ["disabled"]),
                                        _hoisted_104,
                                        _createVNode(_component_Button, {
                                          class: "p-button-sm p-button-secondary",
                                          onClick: _ctx.cancel,
                                          label: "Cancel"
                                        }, null, 8, ["onClick"]),
                                        (_ctx.isLoading)
                                          ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pageError != '')
                ? (_openBlock(), _createBlock(_component_ThePageError, {
                    key: 1,
                    onBackEvent: _ctx.cancel,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}